import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M4.59502 11.888C4.26923 11.888 3.99095 11.7432 3.76018 11.4536L0.244344 7.05538C0.158371 6.9513 0.0950226 6.84949 0.0542986 6.74995C0.0180995 6.6504 0 6.54859 0 6.44452C0 6.20922 0.0769231 6.01465 0.230769 5.86081C0.38914 5.70696 0.588235 5.63004 0.828054 5.63004C1.10407 5.63004 1.3371 5.75447 1.52715 6.00334L4.56787 9.90606L10.4593 0.546328C10.5633 0.387957 10.6697 0.277097 10.7783 0.213748C10.8869 0.145875 11.0271 0.111938 11.1991 0.111938C11.4344 0.111938 11.6267 0.186599 11.776 0.33592C11.9253 0.480717 12 0.670762 12 0.906056C12 1.00108 11.9842 1.09836 11.9525 1.19791C11.9208 1.29293 11.871 1.39474 11.8032 1.50334L5.42308 11.4468C5.22398 11.7409 4.94796 11.888 4.59502 11.888Z"/>
</svg>
`;

export const Checkmark = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
